module.exports = __webpack_public_path__ + "img/3_167.f89a3169.png";